export const getSelectedUserIndex = (userId, selectedUsers) =>
  selectedUsers.findIndex(sUser => sUser === userId);

export const isUserSelectDisabled = (
  user,
  selectedUsers,
  maxSelectedUsers,
  isSelected,
  shouldEnableOnlyFinishedUsers
) =>
  !isSelected &&
  ((maxSelectedUsers && selectedUsers.length === maxSelectedUsers) ||
    (shouldEnableOnlyFinishedUsers && !user.finished));

export const getDisabledUserMessage = (
  translations,
  user,
  isTeamReview,
  isSurveyCompleted
) => {
  let unfinishedUserMessage = isTeamReview
    ? translations.disabledUserMessageUnfinishedTeamInProgress
    : translations.disabledUserMessageUnfinishedInProgress;

  if (isSurveyCompleted) {
    unfinishedUserMessage = isTeamReview
      ? translations.disabledUserMessageUnfinishedTeamDone
      : translations.disabledUserMessageUnfinishedDone;
  }

  return !user.finished
    ? unfinishedUserMessage
    : translations.disabledUserMessageLimitReached;
};
